import { CustomerGroupSettingsMessage } from '../../../../../types/CustomerGroupSettingsMessage';
import { updateCustomerGroupSettings } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { useOptimisticMutation } from '../../../../common/hooks/useOptimisticMutation';

export const useCustomerGroupSettingsOptimisticMutation = (customerGroupId: string) => {
    const { mutate, ...rest } = useOptimisticMutation({
        mutationFn: updateCustomerGroupSettings,
        optimisticUpdateOptions: {
            queryKey: queries.customerGroups.detail(customerGroupId)._ctx.settings.queryKey,
            optimisticUpdatesFn: ({
                variables,
            }: {
                prevQueryData: CustomerGroupSettingsMessage;
                variables: {
                    groupId: string;
                    settings: CustomerGroupSettingsMessage;
                };
            }) => {
                return variables.settings;
            },
            invalidateQueryOnSuccess: true,
        },
    });

    const toggleEnforceMfa = (currentSettings: CustomerGroupSettingsMessage) => {
        mutate({
            groupId: customerGroupId,
            settings: {
                ...currentSettings,
                customerGroupId,
                enforceMfa: !currentSettings.enforceMfa,
            },
        });
    };

    const toggleScheduleSharing = (currentSettings: CustomerGroupSettingsMessage) => {
        mutate({
            groupId: customerGroupId,
            settings: {
                ...currentSettings,
                customerGroupId,
                scheduleSharingEnabled: !currentSettings.scheduleSharingEnabled,
            },
        });
    };

    const toggleExcludeEnabled = (currentSettings: CustomerGroupSettingsMessage) => {
        mutate({
            groupId: customerGroupId,
            settings: {
                ...currentSettings,
                customerGroupId,
                scheduleSharingExcludeEnabled: !currentSettings.scheduleSharingExcludeEnabled,
            },
        });
    };

    const updateExcludedCompanyIds = (currentSettings: CustomerGroupSettingsMessage, companyIds: string[]) => {
        mutate({
            groupId: customerGroupId,
            settings: {
                ...currentSettings,
                customerGroupId,
                scheduleSharingExcludedCompanyIds: companyIds,
            },
        });
    };

    return {
        ...rest,
        mutate,
        toggleEnforceMfa,
        toggleScheduleSharing,
        toggleExcludeEnabled,
        updateExcludedCompanyIds,
    };
};
